

export const API_URL = process.env.REACT_APP_API_URL;

export const APP_URL = process.env.REACT_APP_URL;

export const GYPSYBALL_URL = process.env.REACT_APP_GYPSYBALL_URL;

export const AI_API_URL = process.env.REACT_APP_AI_API_URL;

export const AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID=process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;

export const AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI=process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URI;




